// 对Date的扩展，将 Date 转化为指定格式的String
// 月(M)、日(d)、小时(h)、分(m)、秒(s)、季度(q) 可以用 1-2 个占位符，
// 年(y)可以用 1-4 个占位符，毫秒(S)只能用 1 个占位符(是 1-3 位的数字)
// (new Date()).Format("yyyy-MM-dd hh:mm:ss.S") ==> 2006-07-02 08:09:04.423
// (new Date()).Format("yyyy-M-d h:m:s.S")      ==> 2006-7-2 8:9:4.18
Date.prototype.Format = function (fmt) {
  var o = {
    "M+": this.getMonth() + 1, //月份
    "d+": this.getDate(), //日
    "h+": this.getHours(), //小时
    "m+": this.getMinutes(), //分
    "s+": this.getSeconds(), //秒
    "q+": Math.floor((this.getMonth() + 3) / 3), //季度
    "S": this.getMilliseconds() //毫秒
  };
  if (/(y+)/.test(fmt))
    fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
  for (var k in o)
    if (new RegExp("(" + k + ")").test(fmt))
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
  return fmt;
}

export function formatTimeToStr(times, pattern) {
  var d = new Date(times).Format("yyyy-MM-dd hh:mm:ss");
  if (pattern) {
    d = new Date(times).Format(pattern);
  }
  return d.toLocaleString();
}

export function diff24HourLater(timestamp){
  const timeOneday = 24 * 60 * 60 *1000;
  const timeOnehour = 60 * 60 *1000;
  const timeOneminute = 60 *1000;

  let time24HourLater = timestamp + timeOneday;
  let date24HourLater = new Date(time24HourLater);

  let dateNow = new Date();
  if(date24HourLater<dateNow){
    return '已过确认时间'
  }
  else{
    let timeNow = dateNow.getTime();
    let timeDiff = date24HourLater - timeNow;
    let dayDiff = Math.floor(timeDiff/timeOneday)
    let hourDiff = Math.floor((timeDiff%timeOneday)/timeOnehour)
    let minuteDiff = Math.floor((timeDiff%timeOnehour)/timeOneminute)
    return '还剩下' + dayDiff + '天' + hourDiff + '小时' + minuteDiff + '分'
  }
}

export function diffAppointStart(timePlan){
  const timeOneday = 24 * 60 * 60 *1000;
  const timeOnehour = 60 * 60 *1000;
  const timeOneminute = 60 *1000;

  let dateNow = new Date();
  let timeNow = dateNow.getTime();
  let timeDiff = timePlan - timeNow;

  let timeDiffAbs = Math.abs(timeDiff);
  let dayDiff = Math.floor(timeDiffAbs/timeOneday)
  let hourDiff = Math.floor((timeDiffAbs%timeOneday)/timeOnehour)
  let minuteDiff = Math.floor((timeDiffAbs%timeOnehour)/timeOneminute)
  if(timeDiff<0){
    return '已过时' + dayDiff + '天' + hourDiff + '小时' + minuteDiff + '分'
  }
  else{
    return '距离开始剩下' + dayDiff + '天' + hourDiff + '小时' + minuteDiff + '分'
  }
}

export function diffDays(date1,date2){
  const timeOneday = 24 * 60 * 60 *1000;
  let time1 = date1.getTime();
  let time2 = date2.getTime();
  let timeDiff = time2 - time1;
  return timeDiff/timeOneday ;
}

export function tomorrow(){
  //可以预约当天
  // const timeOneday = 24 * 60 * 60 *1000;
  const timeOneday = 0;

  let dateNow = new Date();
  let timeTomorrow = dateNow.getTime() + timeOneday;

  return new Date(timeTomorrow);
}

export function daysLater(dayNum){
  const timeOneday = 24 * 60 * 60 *1000;

  let dateNow = new Date();
  let time14Later = dateNow.getTime() + dayNum * timeOneday;

  return new Date(time14Later);
}
